export default function ({ route, app }) {
    if (process.client && (route.path !== '/' )) {
        window.scrollTo(0, 0);
    }
}
